"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _variables = require("@blockwell/variables");
class DumbappVariable {
  constructor(api) {
    (0, _defineProperty2.default)(this, "settings", DumbappVariable.settings);
    (0, _defineProperty2.default)(this, "type", "dumbapp");
    (0, _defineProperty2.default)(this, "valueType", "dumbapp");
    (0, _defineProperty2.default)(this, "label", "Dumbapp (bApp)");
    (0, _defineProperty2.default)(this, "description", "Load a dumbapp into a variable.");
    this.api = api;
  }
  dependencies(params, resolver) {
    let shortcode = resolver.resolveString(params.shortcode);
    return {
      shortcode
    };
  }
  getValue(ref, deps, batcher) {
    if (!deps) {
      return null;
    }
    let {
      shortcode
    } = deps;
    if (!shortcode) {
      ref.value = null;
      return;
    }
    if (shortcode.length !== 6) {
      return new _variables.ValueTypeError("invalid_shortcode", "Invalid dumbapp shortcode>");
    }
    return (0, _variables.handleValuePromise)(ref, this.api.getDumbapp(shortcode));
  }
}
exports.DumbappVariable = DumbappVariable;
(0, _defineProperty2.default)(DumbappVariable, "settings", {
  shortcode: {
    type: "dumbapp",
    description: "Shortcode for the dumbapp to load."
  }
});
//# sourceMappingURL=DumbappVariable.js.map